import { render } from "./Navigation.vue?vue&type=template&id=5d8f1ba6&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=5d8f1ba6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\hes-chauffeurs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8f1ba6"]])

export default __exports__